import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material';
import { MaterialModule } from './../../material.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonContainerComponent } from './common-container.component';



@NgModule({
  declarations: [CommonContainerComponent],
  imports: [
    CommonModule,MaterialModule,MatIconModule,FlexLayoutModule,RouterModule
  ],
  exports:[CommonContainerComponent]
})
export class CommonContainerModule { }
